export function getEmployeeFrequentFlyerCode(
  program: string,
  employee?: App.BusinessTraveller.EmployeeFromMeEndpoint,
): string {
  if (!employee?.employeeFrequentFlyer) {
    return ''
  }

  const frequentFlyer = employee.employeeFrequentFlyer.find(
    (ff) => ff.program === program,
  )

  return frequentFlyer ? frequentFlyer.code : ''
}
